import { StringEditor } from "@serenity-is/corelib";
import { formatDate, isEmptyOrNull, notifyError } from "@serenity-is/corelib/q";
import { WarrantyPublicEndPointService } from "../../../ServerTypes/Warranty/Public.WarrantyPublicEndPointService";
$(function () {
    new WarrantyCheckStatus();
});
export class WarrantyCheckStatus {
    constructor() {
        var serialNumberEditor = new StringEditor($('#serialNumber'));
        //$('#warranty-check-button').attr('disabled', 'disabled');
        //$('#warranty-check-button').addClass('disabled');
        serialNumberEditor.element.focus();

        //serialNumberEditor.change(e => {
        //    if (!isEmptyOrNull(serialNumberEditor.value)) {
        //        $('#warranty-check-button').removeAttr('disabled');
        //        $('#warranty-check-button').removeClass('disabled');
        //    } else {
        //        $('#warranty-check-button').attr('disabled', 'disabled');
        //        $('#warranty-check-button').addClass('disabled');
        //    }
        //});
        serialNumberEditor.element.on('keypress', (e) => {
            if (e.which == 13) {
                $('button#warranty-check-button').trigger('click');
            }
        });

        $('input[type=text]').change(e => {
            let el = $(e.target);
            el.parent().find('label.error').hide();
            el.removeClass('error');
            if (isEmptyOrNull(el.val())) {
                el.addClass('error');
                el.parent().find('label.error').show();
            } 
        });

        $('button#warranty-check-button').click(e => {
            var isError = false;
            $('label.error').hide();
            $('input.error').removeClass('error');
            if (isEmptyOrNull(serialNumberEditor.value)) {
                isError = true;
                serialNumberEditor.element.addClass('error');
                serialNumberEditor.element.parent().find('label.error').show();
                return;
            }
            $('.btn').attr('disabled', 'disabled');
            $('.btn').addClass('disabled');
            WarrantyPublicEndPointService.ServiceRequestStatus({
                SerialNumber: serialNumberEditor.value
            }, response => {
                $('.btn').removeAttr('disabled');
                $('.btn').removeClass('disabled');
                $('hr').show();
                if (!response.IsSuccess) {
                    $('#result-container').html(`
                        <div class="alert alert-danger" role="alert">
                            ${response.Message}
                        </div>
                    `);
                } else {
                    $('#result-container').html(`
                        <div class="alert alert-success" role="alert">
                           We found the information for Serial #, below are the details:
                        </div>
                        <table class="table table-bordered table-striped table-success table-check-status">
                            <tbody>
                                <tr>
                                    <th>Serial Number</th>
                                    <td>${response.Entity.SerialNumber ?? ''}</td>
                                </tr>
                                <tr>
                                    <th>Make</th>
                                    <td>${response.Entity.ChassisMake ?? ''}</td>
                                </tr>
                                <tr>
                                    <th>Model</th>
                                    <td>${response.Entity.ChassisModel ?? ''}</td>
                                </tr>
                                <tr>
                                    <th>Dealer</th>
                                    <td>${response.Entity.CustomerName ?? ''}</td>
                                </tr>
                                <tr>
                                    <th>Unit In-Service Date</th>
                                    <td>${isEmptyOrNull(response.UnitInServiceDate) ? '' : formatDate(response.UnitInServiceDate, 'MM/dd/yyyy')} </td>
                                </tr>
                            </tbody>
                        </table>
                     `);
                }
            });
        });
    }
}